import { Link } from "react-router-dom";
import { Video, Clock, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APPT_STATUS, fmtTime, joinable } from "@/lib/livecoach";

export const AppointmentCard = ({ a, meId, onRespond, onCancel, onThread }) => {
  const s = APPT_STATUS[a.status] || { label: a.status, color: "#94A3B8" };
  const iAmCoach = meId === a.coach_user_id;
  const other = iAmCoach ? a.athlete_name : a.coach_name;
  const myTurn = a.action_required_by === (iAmCoach ? "coach" : "athlete");
  const open = ["requested_by_athlete", "proposed_by_coach", "alternate_proposed"].includes(a.status);
  return (
    <div className="rounded-xl border border-[var(--ink-border)] p-4" style={{ backgroundColor: "var(--ink-2)" }} data-testid={`lc-appt-${a.appt_id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full" style={{ color: s.color, backgroundColor: `${s.color}1a` }} data-testid={`lc-status-${a.appt_id}`}>{s.label}</span>
            {open && (
              <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ color: myTurn ? "#0b1424" : "#94A3B8", backgroundColor: myTurn ? "#F59E0B" : "#ffffff10" }}>
                {myTurn ? "Your move" : `Waiting on ${a.action_required_by}`}
              </span>
            )}
          </div>
          <div className="text-white font-bold mt-1.5 truncate">{a.objective}</div>
          <div className="text-xs text-white/50 mt-0.5">
            {iAmCoach ? "Athlete" : "Coach"}: <span className="text-white/80 font-semibold">{other}</span> · {a.duration_minutes} min
          </div>
          <div className="text-xs text-white/60 mt-1 flex items-center gap-1.5">
            <Clock className="h-3 w-3" />
            {a.start_at ? fmtTime(a.start_at) : (a.proposed_times || []).map(fmtTime).join("  ·  ")}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-3 flex-wrap">
        {joinable(a) && (
          <Link to={`/live/${a.appt_id}`} data-testid={`lc-join-${a.appt_id}`}>
            <Button size="sm" className="bg-emerald-500 hover:bg-emerald-400 text-[#04121f] font-black">
              <Video className="h-4 w-4 mr-1.5" /> Join Live Room
            </Button>
          </Link>
        )}
        {open && myTurn && (
          <Button size="sm" variant="outline" className="border-amber-400/40 text-amber-300 hover:bg-amber-400/10" onClick={() => onRespond(a)} data-testid={`lc-respond-${a.appt_id}`}>
            Respond
          </Button>
        )}
        {onThread && (
          <Button size="sm" variant="ghost" className="text-white/60 hover:text-white" onClick={() => onThread(a)} data-testid={`lc-thread-${a.appt_id}`}>
            <MessageSquare className="h-4 w-4 mr-1" /> Thread
          </Button>
        )}
        {!["completed", "declined", "expired", "cancelled_by_coach", "cancelled_by_athlete"].includes(a.status) && (
          <Button size="sm" variant="ghost" className="text-red-400/70 hover:text-red-300" onClick={() => onCancel(a)} data-testid={`lc-cancel-${a.appt_id}`}>
            Cancel
          </Button>
        )}
      </div>
      {a.recap && (
        <div className="mt-3 rounded-lg border border-white/10 bg-white/5 p-3 text-xs text-white/70" data-testid={`lc-recap-${a.appt_id}`}>
          <div className="font-black text-white/90 uppercase tracking-wider text-[10px] mb-1">Session recap · {a.recap.objective_status}</div>
          <div>{a.recap.summary}</div>
          {a.recap.next_actions && <div className="mt-1"><span className="text-white/50">Next:</span> {a.recap.next_actions}</div>}
        </div>
      )}
    </div>
  );
};
